import { createVuetify } from 'vuetify';
import 'vuetify/styles';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases as mdiAliases, mdi } from 'vuetify/iconsets/mdi';
import { fa } from 'vuetify/iconsets/fa';

const customAliases = {
  ...mdiAliases,
  'mdi-eye': 'fas fa-eye',
  'mdi-eye-off': 'fas fa-eye-slash',
  'mdi-lock': 'fas fa-lock',
  'mdi-email-outline': 'fas fa-envelope',
};

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'fa',
    aliases: customAliases,
    sets: { mdi, fa },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary:    '#2E7D5A',
          secondary:  '#3EA272',
          accent:     '#2E7D5A',
          success:    '#2E7D5A',
          warning:    '#F5A623',
          error:      '#E53935',
          background: '#FAFAF7',
          surface:    '#FFFFFF',
        },
      },
    },
  },
});
